(function(w, d) {
	w.createGtagScripts = createGtagScripts;

	function createGtagScripts() {
		const scriptInline = d.createElement('script');
		const scriptExternal = d.createElement('script');
		const id = 'UA-76249469-1';

		d.head.prepend(scriptInline);
		scriptInline.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${id}');`;
		d.head.prepend(scriptExternal);
		scriptExternal.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
		scriptExternal.async = true;
	}
})(window, document);
